import { render, staticRenderFns } from "./DuplicateTradeModal.vue?vue&type=template&id=658a9568&"
import script from "./DuplicateTradeModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateTradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports